import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

import { ClassificationService } from './crm/classification.service';
import { PricelistService } from './crm/pricelist.service';
import { DeliveryMethodService } from './crm/delivery_method.service';
import { PaymentConditionService } from './crm/payment_condition.service';
import { RepresentativeService } from './crm/representative.service';
import { CompanyService } from './crm/company.service';
import { SystemCountryService } from './system-country.service';
import { ProvinceService } from './province.service';
import { SettingsService } from './settings.service';

import { User } from '../models/index';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map'

@Injectable()
export class AuthenticationService {
	constructor(
		private http: HttpClient,
		private translate: TranslateService,
		private settingsService: SettingsService,
		private classService: ClassificationService,
		private pricelistService: PricelistService,
		private dmService: DeliveryMethodService,
		private pcService: PaymentConditionService,
		private reprService: RepresentativeService,
		private countryService: SystemCountryService,
		private provinceService: ProvinceService,
		private companyService: CompanyService
	) {
        this.showLoaderChange.subscribe((value) => {
            this.showLoader = value
        });
	}

    setShowLoader(show: boolean) {
        this.showLoaderChange.next(show);
    }

	private needsCheck = true;
	private _user: User = null;
	get user():User {
		return this._user;
	}
	public loaded = true;

	showLoader: boolean;
	showLoaderChange: Subject<boolean> = new Subject<boolean>();

	login(email: string, password: string): Observable<LoginResponse> {
		return this.http.post<LoginResponse>('/api/v1/authenticate/login', {
			email: email,
			password: password
		}).map(data => {
			this._user = data.user;

			if(data.auth) {
				this.setLoggedIn();
			}

			return data;
		});
	}

	isLoggedIn(): Observable<boolean> {
		console.log("isLoggedIn(): start");
		if(!this.needsCheck) {
			return Observable.of(!!localStorage.getItem('isLoggedin'));
		}

		console.log("isLoggedIn(): Loginstatus needs check");

		let getUser = !this._user;
		return this.http.post<LoginResponse>('/api/v1/authenticate/check', {
			getUser: getUser
		}).map(data => {
			if(getUser) {
				this._user = data.user;
			}

			this.needsCheck = false;
			setTimeout(()=>this.needsCheck=true, (5 * 60 * 1000));

			if(data.auth) {
				this.setLoggedIn();
			} else {
				this.setLoggedOut();
			}

			console.log("isLoggedIn(): returns " + (data.auth ? "true" : 'false'));

			return data.auth;
		});
	}

	logout() {
		this.setLoggedOut();
		this._user = new User;
		return this.http.get('/api/v1/authenticate/logout').subscribe(() => {});
	}

		setLoggedOut() {
			localStorage.removeItem('isLoggedin');
			this.setShowLoader(true);
		}

		setLoggedIn() {
			localStorage.setItem('isLoggedin', 'true');

			this.setShowLoader(false);
			let groupedObservables = Observable.forkJoin(
				this.classService.loadItems(),
				this.pricelistService.loadItems(),
				this.dmService.loadItems(),
				this.pcService.loadItems(),
				this.reprService.loadItems(),
				this.countryService.loadItems(),
				this.provinceService.loadItems(),
				this.companyService.loadItems(),
				this.settingsService.loadSettings()
			);

			groupedObservables.subscribe(() => {
				this.setShowLoader(true);
			});
		}
}

interface LoginResponse {
	auth: boolean;
	user?: User;
	error?: string;
}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/services/authentication.service.ts